// HAZIRLIK · presentation — type-driven timeline

import { useRef } from "react";
import { SectionShell } from "@/features/landing/components/SectionShell";
import { COPY } from "@/features/landing/content/landing-copy";
import { useHazirlikMotion } from "./Hazirlik.motion";
import styles from "./Hazirlik.module.css";

export function Hazirlik() {
  const scopeRef = useRef<HTMLElement | null>(null);
  useHazirlikMotion(scopeRef);

  return (
    <SectionShell id="hazirlik" ariaLabelledBy="hazirlik-title" tone="paper-warm" container="default">
      <div className={styles.hazirlik} ref={scopeRef as unknown as React.RefObject<HTMLDivElement>}>
        <header className={styles.hazirlik__head}>
          <div>
            <p className={styles.hazirlik__eyebrow}>{COPY.hazirlik.chapter} · {COPY.hazirlik.eyebrow}</p>
            <h2 className={styles.hazirlik__title} id="hazirlik-title">
              {COPY.hazirlik.title}
            </h2>
          </div>
          <p className={styles.hazirlik__body}>{COPY.hazirlik.body}</p>
        </header>

        <ol className={styles.hazirlik__timeline} role="list">
          {COPY.hazirlik.timeline.map((step) => (
            <li key={step.time} className={styles.hazirlik__step}>
              <span className={styles["hazirlik__step-time"]}>{step.time}</span>
              <h3 className={styles["hazirlik__step-label"]}>{step.label}</h3>
              <span className={styles["hazirlik__step-count"]}>{step.count}</span>
            </li>
          ))}
        </ol>
      </div>
    </SectionShell>
  );
}